// @Packages
import React from 'react';
import { View } from 'react-native';
import { AntDesign, MaterialCommunityIcons, Feather } from '@expo/vector-icons';

// @styles
import useStyles from './styles';

interface Props {
  name: string;
  color: string;
  size: number;
}

export interface PropsMain {
  children: React.ReactNode,
  dark: boolean,
}

const AntDesignIcon = ({ name, color, size }: Props) => (
  <AntDesign name={name} size={size} color={color} />);

const MaterialCommunityIcon = ({ name, color, size }: Props) => (
  <MaterialCommunityIcons name={name} size={size} color={color} />);

const FeatherIcon = ({ name, color, size }: Props) => (
  <Feather name={name} size={size} color={color} />);

const IconComponent = ({
  children,
  dark
}: PropsMain) => {
  const styles = useStyles({ dark, children });

  return (
    <View style={styles.iconContainer}>
      {children}
    </View>
  );
};

IconComponent.AntDesignIcon = AntDesignIcon;
IconComponent.MaterialCommunityIcon = MaterialCommunityIcon;
IconComponent.FeatherIcon = FeatherIcon;

export default IconComponent;
